import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';

import CategoryLegend from './CategoryLegend';
import { CHART_SURFACE, tooltip } from './chartTheme';
import { categoryColor, formatAmount } from '../../interaction_pages/commandControlCharts';

ChartJS.register(ArcElement, Tooltip);

// La part retirée : grise, pour qu'elle se voie sans porter de couleur — une
// couleur dit une catégorie, et ce qu'on a économisé n'en est pas une.
const SAVED_COLOR = '#e3eaee';

/**
 * UN DEMI-ANNEAU EN JAUGE. Deux tiennent dans la hauteur d'un anneau.
 *
 * L'anneau entier réduit son arc à mesure qu'on économise. Ici l'arc reste
 * fixe (180°) et la part économisée y est posée en gris : un arc qui
 * rétrécirait ferait recadrer le dessin par chart.js à chaque mesure cochée,
 * le demi-cercle ne remplissant plus sa boîte.
 */
const HalfDoughnutChart = ({ series, data }) => {
  const values = series.categories.map((category) => data[category] || 0);
  const total = values.reduce((acc, v) => acc + v, 0);
  const saved = Math.max(series.standardTotal - total, 0);

  const chartData = {
    labels: [...series.categories, 'Économisé'],
    datasets: [{
      data: [...values, saved],
      backgroundColor: [...series.categories.map((_, i) => categoryColor(series, i)), SAVED_COLOR],
      borderColor: CHART_SURFACE,
      borderWidth: 3,
    }],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    rotation: -90,
    circumference: 180,
    cutout: '68%',
    plugins: {
      legend: { display: false },
      datalabels: { display: false },
      tooltip: tooltip({
        callbacks: {
          label: (context) => ` ${context.label} : ${formatAmount(context.raw)} ${series.unit}`,
        },
      }),
    },
  };

  return (
    <div className="half-doughnut">
      <div className="half-doughnut-chart">
        <Doughnut data={chartData} options={options} />
        <div className="half-doughnut-total">{formatAmount(total)} {series.unit}</div>
      </div>
      <CategoryLegend
        categories={series.categories}
        colorOf={(index) => categoryColor(series, index)}
        values={data}
        unit={series.unit}
        formatValue={formatAmount}
      />
    </div>
  );
};

export default HalfDoughnutChart;
